import { render, staticRenderFns } from "./testFilterComponent.vue?vue&type=template&id=03b23a1d&scoped=true&"
import script from "./testFilterComponent.vue?vue&type=script&lang=js&"
export * from "./testFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b23a1d",
  null
  
)

export default component.exports